type RangeItemsDTO = {
  id: number;
  name: string;
};

export const rangeItems: RangeItemsDTO[] = [
  {
    id: 1,
    name: 'Hoje',
  },
  {
    id: 2,
    name: 'Ontem',
  },
  {
    id: 3,
    name: 'Essa semana',
  },
  {
    id: 4,
    name: 'Esse mês',
  },
  {
    id: 5,
    name: 'Últimos 30 dias',
  },
  {
    id: 6,
    name: 'Últimos 60 dias',
  },
  {
    id: 7,
    name: 'Últimos 90 dias',
  },
  {
    id: 8,
    name: 'Customizado',
  },
];
